<!--suppress ALL -->
<template>
    <v-layout>
        <v-flex xs12>
            <v-layout
                row
                class="chapter__list"
                v-if="$vuetify.breakpoint.xs">
                <v-flex :class="[selectedChapterName == memberDirectoryPageConstant.label.ALL ? 'chapter__list__item active': 'chapter__list__item']"
                        @click="displayAllChapterMembers()">
                    {{memberDirectoryPageConstant.label.ALL}}
                </v-flex>

                <v-flex
                    :class="[selectedChapterName === chapter.name  ? 'chapter__list__item active': 'chapter__list__item']"
                    v-for="(chapter , i) in chapterCommunities"
                    :key="i"
                    @click="setOneClickChapterForDirectory(chapter)">
                    {{chapter.name}}
                </v-flex>

            </v-layout>
            <filter-ribbon
                :persisting-filter-key="persistingFilterKey"
                :member-directory-result="memberDirectoryResult"
                v-if="memberDirectoryResult && memberDirectoryResult.searchRibbonGroup
                               && memberDirectoryResult.searchRibbonGroup.length > 0">
            </filter-ribbon>
            <filter-pills-list
                v-if="selectedFilters"
                :selected-filters="selectedFilterPills"
                :handle-clear="removeAllFilters"
                :handle-close="removeFilter"></filter-pills-list>
            <div v-if="memberDirectoryResult && memberDirectoryResult.excludedPrivateNetworkFilters
                            && memberDirectoryResult.excludedPrivateNetworkFilters.length">
                <v-layout column pt-2>
                    <v-flex
                        v-for="(privateNetwork, index) in memberDirectoryResult.excludedPrivateNetworkFilters"
                        class="private_networks"
                        :key="index"
                        pa-2>
                        <span class="ypo_cta_blue_color">{{privateNetwork.label}}</span>
                        <span class="ypo_red_color">{{privateMessage(privateNetwork)}}</span>
                    </v-flex>
                </v-layout>
            </div>
            <v-layout
                class="rolodex-wrapper"
                row
                v-if="showSortByDropdown || displayRolodex">
                <v-flex class="rolodex-wrapper__sort-by">
                    <sort-by-options :directory-stored-filter-constant="persistingFilterKey" v-if="showSortByDropdown">
                    </sort-by-options>
                </v-flex>
                <v-flex
                    xs7
                    sm9
                    md10>
                    <rolodex
                        v-if="displayRolodex"
                        :filtered-letters-list="letterFilters"
                        :rolodex-directory-name="persistingFilterKey"
                        :set-directory-selected-letter="handleSelectedLetter"
                        :selected-letter-filter="memberDirectorySelectedLetterFilter"
                        :reset-selected-letter="removeSelectedLetter">
                    </rolodex>
                </v-flex>
            </v-layout>

            <member-search-results :filter-by-chapter="selectedChapterName" :filter-letter="selectedLetterForLastName"></member-search-results>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import MemberSearchResults from './MemberSearchResults/MemberSearchResults';
    import { memberDirectoryPageConstant, privateCommunityMessage } from './memberDirectoryPage.constants';
    import { storeAction } from "../../store/storeActions.constant";
    import FilterRibbon from "./FilterRibbon/FilterRibbon";
    import Rolodex from "./Rolodex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import FilterPill from "./FilterPill/FilterPill";
    import FilterPillsList from "./FilterPill/FilterPillsList";
    import { storeMutation } from "../../store/storeMutations.constant";
    import SortByOptions from "./SortByLastName/SortByOptions";
    import { createFilterFromCommunityData } from "@/components/ChapterPage/communityCommon.constant";
    import { arrayMoveIndex } from "@/common/utils/utils";

    export default {
        name: 'MemberDirectory',
        created() {
            this.clearRibbonState();
            let dataFromRoute = null;
            if (this.$route.query.filters) {
                dataFromRoute = {
                    ...dataFromRoute,
                    filters: JSON.parse(this.$route.query.filters),
                };

                const filtersFromRoute = JSON.parse(this.$route.query.filters);
                if (filtersFromRoute && filtersFromRoute.letterFilter && filtersFromRoute.letterFilter.length) {
                    this.setMemberSelectedLetterFilter(filtersFromRoute.letterFilter[0]);
                }
            }
            if (this.$route.query.searchText) {
                dataFromRoute = {
                    ...dataFromRoute,
                    searchText: this.$route.query.searchText,
                };
            }
            if (dataFromRoute) {
                this.setRibbonWithRouteData(dataFromRoute);
            }

            const additionalFiltersFromRoute = this.$route.query.additionalFilters ? JSON.parse(this.$route.query.additionalFilters) : null;
            this.getInitialMemberDirectoryResult(additionalFiltersFromRoute);
        },
        components: {
            SortByOptions,
            FilterPillsList,
            FilterPill,
            Rolodex,
            FilterRibbon,
            MemberSearchResults,
        },
        props: {
            noResultMessage: {
                type: String,
                default: null,
            },
            persistingFilterKey: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                memberDirectoryPageConstant,
                selectedLetterForLastName: null,
            };
        },
        methods: {
            ...mapActions({
                getMemberDirectorySearchResultByLastName: `memberDirectory/${storeAction.getMemberDirectorySearchResultByLastName}`,
                getInitialMemberDirectoryResult: `memberDirectory/${storeAction.getInitialMemberDirectorySearchResults}`,
                clearAllFilters: `memberDirectory/${storeAction.clearRibbonState}`,
            }),
            ...mapMutations({
                setRibbonWithRouteData: `memberDirectory/${storeMutation.setRibbonStateFromRouter}`,
                removePill: `memberDirectory/${storeMutation.removePillFromState}`,
                clearRibbonState: `memberDirectory/${storeMutation.clearRibbonState}`,
                setMemberSelectedLetterFilter: `memberDirectory/${storeMutation.setMemberSelectedLetterFilter}`,
                setOneClickChapterInState: `memberDirectory/${storeMutation.setOneClickChapterInState}`,
            }),
            handleSelectedLetter(letter) {
                this.setMemberSelectedLetterFilter(letter);
                let filtersFromRoute = this.$route.query.filters ? JSON.parse(this.$route.query.filters) : {};
                filtersFromRoute = {
                    ...filtersFromRoute,
                    letterFilter: [{ ...letter }],
                };
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        filters: JSON.stringify(filtersFromRoute),
                        searchText: this.memberDirectorySearchText ? this.memberDirectorySearchText : '',
                    },
                });
                sessionStorage.setItem(this.persistingFilterKey, JSON.stringify(filtersFromRoute));
            },
            removeSelectedLetter() {
                const filtersFromRoute = this.$route.query.filters ? JSON.parse(this.$route.query.filters) : null;
                if (this.memberDirectorySelectedLetterFilter && filtersFromRoute) {
                    delete filtersFromRoute.letterFilter;
                }
                this.setMemberSelectedLetterFilter();
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        filters: filtersFromRoute ? JSON.stringify(filtersFromRoute) : '',
                        searchText: this.memberDirectorySearchText ? this.memberDirectorySearchText : '',
                    },
                });
                sessionStorage.setItem(this.persistingFilterKey, JSON.stringify(filtersFromRoute));
            },
            privateMessage(privateCommunity) {
                return privateCommunityMessage(privateCommunity);
            },
            removeFilter(filterItem) {
                this.removePill(filterItem);
                sessionStorage.setItem(this.persistingFilterKey, JSON.stringify(this.selectedFilters));
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        filters: JSON.stringify(this.selectedFilters),
                        searchText: this.memberDirectorySearchText,
                    },
                });
            },
            removeAllFilters() {
                let dataFromRoute = { ...this.$route.query };
                if (dataFromRoute && dataFromRoute.hasOwnProperty('filters')) {
                    delete dataFromRoute.filters;
                }

                if (this.memberDirectorySelectedLetterFilter) {
                    dataFromRoute = {
                        ...dataFromRoute,
                        filters: JSON.stringify({
                            letterFilter: [{ ...this.memberDirectorySelectedLetterFilter }],
                        }),
                    };
                }

                if (this.memberDirectorySelectedLetterFilter) {
                    sessionStorage.setItem(
                        this.persistingFilterKey,
                        JSON.stringify({ letterFilter: [{ ...this.memberDirectorySelectedLetterFilter }] }),
                    );
                } else {
                    sessionStorage.removeItem(this.persistingFilterKey);
                }

                this.$router.push({
                    query: { ...dataFromRoute },
                });
            },
            filterBySelectedLetter(letter) {
                this.selectedLetterForLastName = letter;
            },
            setOneClickChapterForDirectory(communityDetails) {
                if (communityDetails.name !== memberDirectoryPageConstant.label.ALL) {
                    const selectedChapterFilter =
                        createFilterFromCommunityData(communityDetails, memberDirectoryPageConstant.constant.selectedOneClickChapter);

                    this.setOneClickChapterInState(selectedChapterFilter[memberDirectoryPageConstant.constant.selectedOneClickChapter])
                    this.$router.push({
                        query: {
                            ...this.$route.query,
                            filters: JSON.stringify(this.selectedFilters),
                            searchText: this.memberDirectorySearchText || '',
                        },
                    });
                    sessionStorage.setItem(this.persistingFilterKey, JSON.stringify(this.selectedFilters));
                }
            },
            displayAllChapterMembers() {
                this.setOneClickChapterInState();
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        filters: JSON.stringify(this.selectedFilters),
                        searchText: this.memberDirectorySearchText || '',
                    },
                });
                sessionStorage.setItem(this.persistingFilterKey, JSON.stringify(this.selectedFilters));
            }
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                memberDirectoryResult: `memberDirectory/${storeGetters.memberDirectorySearchResults}`,
                selectedFilters: `memberDirectory/${storeGetters.selectedMemberDirectoryFilters}`,
                memberDirectorySearchText: `memberDirectory/${storeGetters.memberDirectorySearchText}`,
                memberDirectorySort: `memberDirectory/${storeGetters.memberDirectorySort}`,
                memberDirectorySelectedLetterFilter: `memberDirectory/${storeGetters.memberDirectorySelectedLetterFilter}`,
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
            }),
            displayRolodex() {
                return this.memberDirectoryResult && this.memberDirectoryResult.searchResults &&
                    (this.memberDirectorySelectedLetterFilter || this.memberDirectoryResult.searchResults.length >
                        memberDirectoryPageConstant.constant.minimumCountForLastNameSelector);
            },
            selectedFilterPills() {
                const selectedFilterPillObject = {
                    ...this.selectedFilters,
                };
                if (selectedFilterPillObject.hasOwnProperty('letterFilter')) {
                    delete selectedFilterPillObject.letterFilter;
                }
                return selectedFilterPillObject;
            },
            letterFilters() {
                return this.memberDirectoryResult && this.memberDirectoryResult.quickSearchResults &&
                    this.memberDirectoryResult.quickSearchResults[0] &&
                    this.memberDirectoryResult.quickSearchResults[0].filters ?
                    this.memberDirectoryResult.quickSearchResults[0].filters : [];
            },
            showSortByDropdown() {
                return this.memberDirectoryResult && this.memberDirectoryResult.searchResults &&
                    (this.memberDirectoryResult.searchResults.length > 0 || this.memberDirectorySelectedLetterFilter);
            },
            chapterCommunities() {
                let result = this.usersCommunitiesList.filter(item => item.communityType === 'Chapter');

                if (this.$route.query.filters) {
                    const filtersFromRoute = JSON.parse(this.$route.query.filters);
                    let selectedChapterFromRoute = null;
                    if(filtersFromRoute && filtersFromRoute[memberDirectoryPageConstant.constant.selectedOneClickChapter]
                        && filtersFromRoute[memberDirectoryPageConstant.constant.selectedOneClickChapter].length) {
                        selectedChapterFromRoute =
                            filtersFromRoute[memberDirectoryPageConstant.constant.selectedOneClickChapter][0];
                    }

                    if(selectedChapterFromRoute) {
                        const selectedIndex = result.indexOf(
                            result.find(item => item.searchFilterValue === selectedChapterFromRoute.filterValue)
                        );

                        if(selectedIndex) {
                            result = arrayMoveIndex(result, selectedIndex, 0)
                        }
                    }
                }

                return result;
            },
            selectedChapterName() {
                let selectedChapter = memberDirectoryPageConstant.label.ALL;
                if (this.$route.query.filters) {
                    const filtersFromRoute = JSON.parse(this.$route.query.filters);
                    if(filtersFromRoute && filtersFromRoute[memberDirectoryPageConstant.constant.selectedOneClickChapter]
                        && filtersFromRoute[memberDirectoryPageConstant.constant.selectedOneClickChapter].find(f => f.filterValue)) {
                        selectedChapter =
                            filtersFromRoute[memberDirectoryPageConstant.constant.selectedOneClickChapter]
                                .find(f => f.filterValue).filterValue;
                    }
                }
                return selectedChapter;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .member-directory {
        .private_networks {
            font-size: 16px;
            letter-spacing: -0.01px;
            line-height: 22px;
        }
    }

    .rolodex-wrapper {
        padding-left: 5px;
        padding-top: 5px;
        border-bottom: 1px solid $ypo-light-medium-gray;

        &__sort-by {
            flex: 0 1 auto;
            margin-top: 5px;
        }
    }

    .chapter__list {
        border-top: 1px solid $ypo-medium-gray;
        border-bottom: 1px solid $ypo-medium-gray;
        overflow: auto;
        margin: 15px -5px 0 -5px;

        &__item {
            padding: 10px 15px;
            border-right: 1px solid $ypo-medium-gray;
            white-space: nowrap;
            font-size: 14px;
            text-transform: uppercase;
            text-align: center;

            &:first-child {
                min-width: 115px;
            }

            &:last-child {
                border-right: none;
            }

            &.active {
                background: $ypo-cta;
                color: $white;
            }
        }

        &::-webkit-scrollbar {
            display: none;
        }
    }
</style>
